import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { FetchWorkspaceNotesTagsResultItem, FetchWorkspaceTagsResult, TagInfoDto } from '@nx-frontend/shared/types';

type CreateTagPayload = {
  workspaceId: string;
  userId: number;
  tagName: string;
};
export const createTag = async ({ workspaceId, userId, tagName }: CreateTagPayload): Promise<boolean> => {
  try {
    const host = generalEnv.noteServiceUrl;
    await axiosClient.post(
      `${host}/v1/workspaces/${workspaceId}/tags`,
      {
        tags: [tagName],
      },
      {
        headers: {
          Authorization: `internal ${userId}:auto`,
        },
      }
    );
    return true;
  } catch (err) {
    return false;
  }
};

type RenameTagPayload = {
  workspaceId: string;
  userId: number;
  newTagName: string;
  oldTagName: string;
};
export const renameWorkspaceTagInternal = async ({
  workspaceId,
  userId,
  newTagName,
  oldTagName,
}: RenameTagPayload): Promise<boolean> => {
  try {
    const host = generalEnv.noteServiceUrl;
    await axiosClient.post(
      `${host}/v1/workspaces/${workspaceId}/tags/${encodeURIComponent(oldTagName)}`,
      {
        tag: newTagName,
      },
      {
        headers: {
          Authorization: `internal ${userId}:auto`,
        },
      }
    );
    return true;
  } catch (err) {
    return false;
  }
};

type SetNoteTagsPayload = {
  workspaceId: string;
  userId: number;
  noteId: string;
  tags: string[];
};
export const setNoteTags = async ({ workspaceId, userId, noteId, tags }: SetNoteTagsPayload): Promise<boolean> => {
  try {
    const host = generalEnv.noteServiceUrl;
    await axiosClient.post(`${host}/v1/workspaces/${workspaceId}/notes/${noteId}/tags`, tags, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });
    return true;
  } catch (err) {
    return false;
  }
};

type GetNoteTagsPayload = {
  workspaceId: string;
  userId: number;
  noteId: string;
};
export const fetchNoteTags = async ({ workspaceId, userId, noteId }: GetNoteTagsPayload): Promise<string[] | null> => {
  try {
    const host = generalEnv.noteServiceUrl;
    const response = await axiosClient.get(`${host}/v1/workspaces/${workspaceId}/notes/${noteId}/tags`, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });
    return response.data;
  } catch (err) {
    console.log(`getTags error: ${err}`);
    return null;
  }
};

type GetWorkspaceTagsPayload = {
  workspaceId: string;
  userId: number;
};
export const fetchTagsInfos = async ({
  workspaceId,
  userId,
}: GetWorkspaceTagsPayload): Promise<FetchWorkspaceTagsResult | null> => {
  try {
    const host = generalEnv.noteServiceUrl;
    const response = await axiosClient.get<TagInfoDto[]>(`${host}/v1/workspaces/${workspaceId}/tagsInfos`, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });
    return { workspaceId, tags: response.data };
  } catch (err) {
    console.log(`getTags error: ${err}`);
  }
  return null;
};

type GetWorkspaceNotesTagsPayload = {
  workspaceId: string;
  userId: number;
};
export const fetchWorkspaceNotesTags = async ({
  workspaceId,
  userId,
}: GetWorkspaceNotesTagsPayload): Promise<FetchWorkspaceNotesTagsResultItem[] | null> => {
  try {
    const host = generalEnv.noteServiceUrl;
    const response = await axiosClient.get<FetchWorkspaceNotesTagsResultItem[]>(
      `${host}/v1/workspaces/${workspaceId}/noteTags`,
      {
        headers: {
          Authorization: `internal ${userId}:auto`,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.log(`getNotesTags error: ${err}`);
  }
  return null;
};

type DeleteWorkspaceTagsPayload = {
  workspaceId: string;
  userId: number;
  tags: string[];
};
export const deleteWorkspaceTags = async (params: DeleteWorkspaceTagsPayload) => {
  try {
    const host = generalEnv.noteServiceUrl;
    await axiosClient.delete(`${host}/v1/workspaces/${params.workspaceId}/tags`, {
      data: { tags: params.tags },
      headers: {
        Authorization: `internal ${params.userId}:auto`,
      },
    });
    return true;
  } catch (err) {
    return false;
  }
};

type AddTagToNotePayload = {
  workspaceId: string;
  noteId: string;
  userId: number;
  tag: string;
};
export const addTagToNoteInternal = async ({
  workspaceId,
  noteId,
  userId,
  tag,
}: AddTagToNotePayload): Promise<boolean> => {
  try {
    const host = generalEnv.noteServiceUrl;
    await axiosClient.post(
      `${host}/v1/workspaces/${workspaceId}/notes/${noteId}/tags/${encodeURIComponent(tag)}`,
      {},
      {
        headers: {
          Authorization: `internal ${userId}:auto`,
        },
      }
    );
    return true;
  } catch (err) {
    return false;
  }
};

type DeleteTagFromNotePayload = {
  workspaceId: string;
  noteId: string;
  userId: number;
  tag: string;
};
export const deleteTagFromNoteInternal = async ({
  workspaceId,
  noteId,
  userId,
  tag,
}: DeleteTagFromNotePayload): Promise<boolean> => {
  try {
    const host = generalEnv.noteServiceUrl;
    await axiosClient.delete(`${host}/v1/workspaces/${workspaceId}/notes/${noteId}/tags/${encodeURIComponent(tag)}`, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });
    return true;
  } catch (err) {
    return false;
  }
};
